import React, { useState, useEffect, memo } from 'react';
import Card from '../../components/Card/Card';
import { makeStyles } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import axiosInstance from '../../axiosInstance';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles({
  projects: {
    width: '100%',
    height: 'calc(100% - 112px)',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '30px 200px 30px 200px'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  firstRow: {
    paddingTop: '30px'
  },
  secondRow: {
    paddingTop: '10px'
  },
  category: {
    minWidth: '126px'
  },
  active: {
    color: 'rgb(55, 71, 172)'
  },
  inactive: {
    color: 'rgb(88, 101, 109)'
  },
  backdrop: {
    zIndex: 99999,
    // Prevent the user from selecting the text.
    userSelect: 'none',
    msUserSelect: 'none',
    msTouchSelect: 'none',
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    cursor: 'default'
  }
});

const Projects = () => {
  const classes = useStyles();
  const [checked, setChecked] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(true);
  const [projects, setProjects] = useState([]);
  const [category, setCategory] = useState('');

  const isProjectsSelected = !checked;

  useEffect(() => {
    const normalizeAndSetProjects = (responseData) => {
      const normalizedProjects = Object.values(responseData).map((userProjects) => Object.keys(userProjects).map((userProjectId) => {
        return {
          ...userProjects[userProjectId],
          id: userProjectId
        };
      })).flat();

      setProjects(normalizedProjects);
    };


    const fetchProjects = async () => {
      const response = await axiosInstance('.json');

      normalizeAndSetProjects(response.data);

      setBackdropOpen(false);
    };

    fetchProjects();
  }, []);

  const onSwitchChanged = () => {
    setChecked(!checked);
  };

  const onCategoryChanged = (event) => {
    setCategory(event.target.value);
  };

  return (
    <div className={classes.projects}>
      <div className={`${classes.row} ${classes.firstRow}`}>
        <Typography
          variant="h4"
          color="textSecondary"
          component="p"
          className={isProjectsSelected ? classes.active : classes.inactive}
        >
          Projects
        </Typography>
        <Switch color="default" onChange={onSwitchChanged} />
        <Typography
          variant="h4"
          color="textSecondary"
          component="p"
          className={isProjectsSelected ? classes.inactive : classes.active}
        >
          Vouchers
        </Typography>
      </div>
      <div className={`${classes.row} ${classes.secondRow}`}>
        <FormControl className={classes.category}>
          <InputLabel>Filter category</InputLabel>
          <Select
            value={category}
            onChange={onCategoryChanged}
            className={classes.category}
          >
            <MenuItem value={"All"}>All</MenuItem>
            {
              Array.from(new Set(projects.map((project) => project.category))).filter((category) => category !== 'Other').map((category) => {
                return <MenuItem value={category} key={category}>{category}</MenuItem>;
              })
            }
            <MenuItem value={"Other"}>Other</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className={classes.container}>
        {
          isProjectsSelected ?
            projects.filter((project) => category === '' || category === 'All' ? true : project.category === category).map((project) => {
              const creationDate = new Date(project.creationDate).toDateString();

              return (
                <Card
                  projectId={project.id}
                  key={project.id}
                  name={project.name || 'Project'}
                  creationDate={creationDate}
                  category={project.category || 'Other'}
                  description={project.description || 'Description'}
                  image={project.image}
                  creatorName={project.creator.name}
                  creatorPhoto={project.creator.photoURL}
                  clickable={true}
                  showHeader={true}
                />
              );
            }) :
            [...projects.filter((project) => category === '' || category === 'All' ? true : project.category === category).map((project) => {
              const creationDate = new Date(project.creationDate).toDateString();

              if (typeof project.vouchers === 'undefined') {
                return;
              }

              return project.vouchers.map((voucher, index) => {
                return (
                  <Card
                    projectId={project.id}
                    key={project.id + index}
                    name={voucher.name || 'Project'}
                    creationDate={creationDate}
                    category={project.category || 'Other'}
                    description={voucher.description || 'Description'}
                    image={project.image}
                    creatorName={project.creator.name}
                    creatorPhoto={project.creator.photoURL}
                    additionalPrice={voucher.additionalPrice}
                    originalPrice={voucher.originalPrice}
                    voucherPrice={voucher.voucherPrice}
                    clickable={true}
                    showHeader={true}
                  />
                );
              });
            })]
        }
      </div>
      <Backdrop
        className={classes.backdrop}
        open={backdropOpen}
      >
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
  );
};

export default memo(Projects);
